(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-collage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    function initCell(imgA) {
      var raw = imgA.getAttribute('data-frames') || '';
      var extra = raw.split('|').filter(Boolean);
      if (!extra.length) return;

      var frames = [imgA.getAttribute('src')];
      var pending = extra.length;

      extra.forEach(function (url) {
        var probe = new Image();
        probe.onload = function () { frames.push(url); done(); };
        probe.onerror = done;
        probe.src = url;
      });

      function done() {
        pending -= 1;
        if (pending <= 0) start();
      }

      function start() {
        if (frames.length < 2) return;

        // Second stacked layer for a true crossfade (no fade-through-white).
        var imgB = imgA.cloneNode(false);
        imgB.removeAttribute('data-frames');
        imgB.setAttribute('aria-hidden', 'true');
        imgB.setAttribute('alt', '');
        imgB.setAttribute('loading', 'eager');
        imgB.style.opacity = '0';
        imgA.parentNode.appendChild(imgB);

        var layers = [imgA, imgB];
        var visible = 0;
        var i = 0;

        setInterval(function () {
          i = (i + 1) % frames.length;
          var incoming = layers[1 - visible];
          var outgoing = layers[visible];
          var url = frames[i];

          var reveal = function () {
            incoming.style.opacity = '1';
            outgoing.style.opacity = '0';
            visible = 1 - visible;
          };

          if (incoming.getAttribute('src') === url) {
            reveal();
          } else {
            incoming.onload = reveal;
            incoming.setAttribute('src', url);
          }
        }, 4500);
      }
    }

    document.querySelectorAll('.gc__img[data-frames]').forEach(initCell);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["physiq-product-detail"] && !Shopify.designMode) return;
  try {
    
  class PhysiqProductDetail {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.dp__form');
      this.variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      this.currency = root.dataset.currency || 'PHP';
      this.inputs = [...root.querySelectorAll('[data-option-input]')];
      this.optionGroups = [...root.querySelectorAll('[data-option-group]')];
      this.variantInput = root.querySelector('[data-variant-id]');
      this.price = root.querySelector('[data-current-price]');
      this.image = root.querySelector('#PhysiqProductImage');
      this.galleryButtons = [...root.querySelectorAll('[data-gallery-thumb]')];
      this.galleryTrack = root.querySelector('[data-gallery-track]');
      this.productThumbnail = root.querySelector('[data-product-thumbnail]');
      this.addButton = root.querySelector('[data-add-to-cart]');
      this.buyButton = root.querySelector('[data-buy-now]');
      this.addLabel = root.querySelector('[data-add-label]');
      this.status = root.querySelector('[data-product-status]');

      this.inputs.forEach((input) => input.addEventListener('change', () => this.update()));
      this.galleryButtons.forEach((button) => button.addEventListener('click', () => this.selectGalleryImage(button)));
      root.querySelectorAll('[data-gallery-nav]').forEach((button) => {
        button.addEventListener('click', () => this.scrollGallery(button.dataset.galleryNav));
      });
      this.buyButton?.addEventListener('click', () => this.buyNow());
      this.update();
    }

    selectedOptions() {
      return this.optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    }

    matchingVariant(options) {
      return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-PH', {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    }

    updateBundlePrices(options) {
      const bundleGroup = this.root.querySelector('[data-option-kind="bundle"]');
      if (!bundleGroup) return;
      const bundleIndex = Number(bundleGroup.dataset.optionIndex);

      bundleGroup.querySelectorAll('[data-option-card]').forEach((card) => {
        const candidate = [...options];
        candidate[bundleIndex] = card.dataset.optionValue;
        const variant = this.matchingVariant(candidate);
        const input = card.querySelector('input');
        const price = card.querySelector('[data-bundle-price]');
        const compare = card.querySelector('[data-bundle-compare]');
        const save = card.querySelector('[data-bundle-save]');

        input.disabled = !variant || !variant.available;
        if (!variant) {
          price.textContent = 'Unavailable';
          compare.hidden = true;
          save.hidden = true;
          return;
        }

        price.textContent = this.formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = this.formatMoney(variant.compare_at_price);
          compare.hidden = false;
          save.textContent = `Save ${this.formatMoney(variant.compare_at_price - variant.price)}`;
          save.hidden = false;
        } else {
          compare.hidden = true;
          save.hidden = true;
        }
      });
    }

    updateColorAvailability(options) {
      const colorGroup = this.root.querySelector('[data-option-kind="color"]');
      if (!colorGroup) return;
      const colorIndex = Number(colorGroup.dataset.optionIndex);
      colorGroup.querySelectorAll('[data-option-card]').forEach((card) => {
        const candidate = [...options];
        candidate[colorIndex] = card.dataset.optionValue;
        const input = card.querySelector('input');
        input.disabled = !this.matchingVariant(candidate)?.available;
      });
    }

    updateImage(variant) {
      const preview = variant?.featured_media?.preview_image;
      if (!preview?.src || !this.image) return;

      this.image.src = preview.src;
      this.image.srcset = '';
      this.image.alt = variant.name || this.image.alt;

      if (this.productThumbnail) {
        this.productThumbnail.dataset.gallerySrc = preview.src;
        this.productThumbnail.dataset.gallerySrcset = '';
        this.productThumbnail.dataset.galleryAlt = variant.name || this.image.alt;
        const thumbnailImage = this.productThumbnail.querySelector('img');
        if (thumbnailImage) {
          thumbnailImage.src = preview.src;
          thumbnailImage.srcset = '';
        }
        this.setActiveThumbnail(this.productThumbnail);
      }
    }

    setActiveThumbnail(activeButton) {
      this.galleryButtons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (activeButton && this.galleryTrack) {
        const left = activeButton.offsetLeft - this.galleryTrack.offsetLeft - ((this.galleryTrack.clientWidth - activeButton.offsetWidth) / 2);
        this.galleryTrack.scrollTo({ left, behavior: 'smooth' });
      }
    }

    selectGalleryImage(button) {
      if (!this.image || !button?.dataset.gallerySrc) return;
      this.image.removeAttribute('srcset');
      if (button.dataset.gallerySrcset) {
        this.image.srcset = button.dataset.gallerySrcset;
      }
      this.image.src = button.dataset.gallerySrc;
      this.image.alt = button.dataset.galleryAlt || '';
      this.setActiveThumbnail(button);
    }

    scrollGallery(direction) {
      if (!this.galleryTrack) return;
      const distance = Math.max(this.galleryTrack.clientWidth * 0.75, 184);
      this.galleryTrack.scrollBy({
        left: direction === 'previous' ? -distance : distance,
        behavior: 'smooth'
      });
    }

    update() {
      const options = this.selectedOptions();
      const variant = this.matchingVariant(options);
      this.updateBundlePrices(options);
      this.updateColorAvailability(options);

      if (!variant) {
        this.variantInput.value = '';
        this.price.textContent = 'Unavailable';
        this.addButton.disabled = true;
        this.buyButton.disabled = true;
        this.addLabel.textContent = 'Unavailable';
        return;
      }

      this.variantInput.value = variant.id;
      this.price.textContent = this.formatMoney(variant.price);
      this.addButton.disabled = !variant.available;
      this.buyButton.disabled = !variant.available;
      this.addLabel.textContent = variant.available
        ? this.root.dataset.addLabel
        : this.root.dataset.soldOutLabel;
      this.updateImage(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    async buyNow() {
      if (!this.variantInput.value || this.buyButton.disabled) return;
      this.buyButton.disabled = true;
      this.status.textContent = '';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        if (!response.ok) throw new Error('Unable to add this selection to checkout.');
        window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
      } catch (error) {
        this.status.textContent = error.message;
        this.buyButton.disabled = false;
      }
    }
  }

  const initializePhysiqProductDetails = (scope = document) => {
    scope.querySelectorAll('[data-physiq-product]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new PhysiqProductDetail(root);
    });
  };

  initializePhysiqProductDetails();
  document.addEventListener('shopify:section:load', (event) => initializePhysiqProductDetails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pgt').forEach(function (section) {
      var tabs = section.querySelectorAll('.pgt__tab');
      var cards = section.querySelectorAll('.pcard');
      if (!tabs.length) return;

      function applyFilter(filter) {
        cards.forEach(function (card) {
          var show = filter === 'all' || card.getAttribute('data-cat') === filter;
          card.toggleAttribute('hidden', !show);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          applyFilter(tab.getAttribute('data-filter'));
        });
      });

      cards.forEach(function (card) {
        var image = card.querySelector('.pcard__media img');
        var links = card.querySelectorAll('[data-product-link]');
        var price = card.querySelector('[data-card-price]');
        var swatches = card.querySelectorAll('[data-card-swatch]');

        swatches.forEach(function (swatch) {
          swatch.addEventListener('click', function () {
            swatches.forEach(function (item) {
              item.classList.remove('is-active');
              item.setAttribute('aria-pressed', 'false');
            });

            swatch.classList.add('is-active');
            swatch.setAttribute('aria-pressed', 'true');

            if (image) {
              image.src = swatch.dataset.imageSrc;
              image.srcset = swatch.dataset.imageSrcset || '';
              image.alt = card.querySelector('.pcard__title')?.textContent.trim() + ' — ' + swatch.dataset.colorName;
            }

            links.forEach(function (link) {
              link.href = swatch.dataset.variantUrl;
            });

            if (price && swatch.dataset.variantPrice) {
              price.textContent = swatch.dataset.variantPrice;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
